import React from 'react';
import { Outlet, Link } from 'react-router-dom';

import { Row, Col } from 'react-bootstrap';

import routes from 'app/routes';

import Table from './Table';

export default function Index({ enterpriseId, briefs, refresh }) {
  return (
    <div className="ibox-content mt20">
      <Row>
        <Col md={6}>
          <h2 className="block-title">Enterprise Briefs</h2>
        </Col>
        <Col md={6} className="text-right">
          <Link
            to={routes.admin.enterprise_briefs.new(enterpriseId)}
            className="btn btn-primary"
          >
            Add Brief
          </Link>
        </Col>
      </Row>
      <Table enterpriseId={enterpriseId} briefs={briefs} refresh={refresh} />
      <Outlet />
    </div>
  );
}
